import { Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Event } from "types";
import { useResource } from "../../hooks/useResource";
import { useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { SecondaryButton } from "../Common/SecondaryButton";
import { WaitlistTimeslotSummaryTile } from "../Event/WaitlistTimeslotSummaryTile";
import { ContentLayout } from "../Layout/ContentLayout";
import { Loader } from "../Loader";
import { CreatePurchaseFooter } from "./CreatePurchaseFooter";
import { CreatePurchaseSidebar } from "./CreatePurchaseSidebar";

export const WaitlistSuccessScreen = () => {
    const history = useHistory();
    const resetState = useCreatePurchaseStore((state) => state.actions.resetState);
    const eventId = useCreatePurchaseStore((state) => state.eventId);
    const timeslot = useCreatePurchaseStore((state) => state.getActiveItem().timeslot);

    const { isLoading } = useResource<Event>(["events", eventId]);

    const handleCancel = () => {
        resetState();
        history.push("/cart/init");
    };

    const handleAddNewProductClick = () => {
        history.push("/cart/init", { isAddingItem: true });
    };

    return (
        <div className="grid h-full grid-cols-12">
            <ContentLayout isWide classNames={{ root: "relative col-span-6 h-full 2xl:col-span-7" }}>
                <div className="space-y-2 rounded bg-yellow-lighter p-4">
                    <h3>Joined Waitlist</h3>
                    <div className="text-gray-darker">You have successfully added the customer to the waitlist.</div>
                    {isLoading ? <Loader /> : <WaitlistTimeslotSummaryTile timeslot={timeslot!} className="mb-0" />}
                </div>
                <CreatePurchaseFooter secondaryText="Cancel" onCancel={handleCancel}>
                    <Button onClick={handleCancel}>Close</Button>

                    <SecondaryButton disabled onClick={handleAddNewProductClick}>
                        Add Another Product
                    </SecondaryButton>
                </CreatePurchaseFooter>
            </ContentLayout>

            <div className="col-span-6 shrink-0 space-y-6 bg-gray-lighter 2xl:col-span-5">
                <CreatePurchaseSidebar />
            </div>
        </div>
    );
};
